import { useCallback, useState } from "react";

/** Boolean UI preference remembered in localStorage (e.g. a collapsed sidebar). */
export function useLocalFlag(key: string, initial = false): [boolean, (v: boolean) => void] {
  const [value, setValue] = useState(() => {
    try {
      const v = localStorage.getItem(key);
      return v === null ? initial : v === "1";
    } catch {
      return initial;
    }
  });
  const set = useCallback((v: boolean) => {
    setValue(v);
    try { localStorage.setItem(key, v ? "1" : "0"); } catch { /* ignore */ }
  }, [key]);
  return [value, set];
}
